import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import ResultCard from '../containers/ResultCard';

const Header = styled.div(({theme}) => `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  color: ${theme.primaryColor};
  margin-bottom: 24px;

  h2 {
    font-size: 18px;
    font-weight: 800;
    letter-spacing: -0.6px;
    line-height: 22px;
    @media ${theme.mobile} {
      font-size: 14px;
      line-height: 18px
    }
  }

  h3 {
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    margin: 4px 0 0;
  }

  > div:last-of-type {
    margin-left: 8px;
    margin-top: 4px;
    font-size: 30px;
    font-weight: 800;
    line-height: 12px;
  }
`);

const SummaryCard = styled(ResultCard)(({ theme }) => `
  padding: 24px 32px;
  color: ${theme.primaryFontColor};
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: -0.1px;
  @media ${theme.mobile} {
    padding: 24px 16px;
  };
`)

const ResultSummary = ({ title, subtitle, score, children }) => (
  <SummaryCard>
    <Header>
      <div>
        <h2>{title}</h2>
        {subtitle && <h3>{subtitle}</h3>}
      </div>
      <div>{score}</div>
    </Header>
    {children}
  </SummaryCard>
);

ResultSummary.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  score: PropTypes.element.isRequired,
  children: PropTypes.any,
};

ResultSummary.defaultProps = {
  subtitle: null,
  children: null,
};

export default ResultSummary;
